import { Box } from '@material-ui/core';
import { styled } from '@material-ui/styles';

export const CenteredBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
